import React from "react";
import { Loading } from "../../App";
import Ajax, { domain } from "../ajax/Ajax";
import { DebounceInput } from "react-debounce-input";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import logo from "../../images/logo.png";
import { Helmet } from "react-helmet/es/Helmet";

class AddedStocks extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addedStocks: [],
      filteredStocks: [],
      fetching: true,
      selectDateRange: true,
      filtering: false,
      filterStr: "",
      startDate: null,
      endDate: null,
    };

    this.filterStocks = this.filterStocks.bind(this);
    this.getTotalValue = this.getTotalValue.bind(this);
  }

  async fetchAddedStocks() {
    let param = "?";

    if (this.props.focusObj) {
      param += "focus=" + this.props.focus;
      param += "&focus_id=" + this.props.focusObj.token;

      if (this.state.filterStr) {
        param += "&filter=" + this.state.filterStr;
      }

      if (this.state.startDate) {
        let date = this.state.startDate.format("YYYY-MM-DD");
        console.log(date, "the date string");
        param += "&start_date=" + date;
      }

      if (this.state.endDate) {
        let date = this.state.endDate.format("YYYY-MM-DD");
        param += "&end_date=" + date;
      }

      if (!this.state.filtering) {
        this.setState({ fetching: true });
      }

      let fetchResults = await Ajax.fetchData(
        domain + "/en/api/shop/v1/added-stocks/" + param
      );

      if (fetchResults) {
        if (fetchResults.status === "success") {
          this.setState({
            addedStocks: fetchResults.data,
            fetching: false,
            filtering: false,
          });
        }
      }
    }
  }

  async filterStocks(event) {
    await this.setState({
      filterStr: event.target.value,
      filtering: true,
    });

    await this.fetchAddedStocks();
  }

  async componentDidMount() {
    await this.fetchAddedStocks();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    try {
      if (this.props.focusObj.token !== prevProps.focusObj.token) {
        this.fetchAddedStocks();
      }
    } catch (e) {
      console.log(e);
    }
  }

  getTotalValue() {
    let total = 0;
    let currency = "";
    this.state.addedStocks.forEach((stock) => {
      total += stock.price * stock.qty_added;
      currency = stock.currency;
    });
    return currency + " " + total.toLocaleString();
  }

  render() {
    let filtering = "";
    if (this.state.filtering) {
      filtering = "is-loading";
    }

    return (
      <div>
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Added stock | VehShop</title>
        </Helmet>
        {this.state.fetching && this.state.addedStocks.length < 1 ? (
          <div>
            <Loading />
          </div>
        ) : (
          <div>
            <div className="card is-shadowless bordered-card">
              <div className="card-content">
                <div>
                  <div className="title has-text-centered">Stocks Added</div>
                </div>

                {this.state.fetching ? (
                  <div className="mt-2">
                    <Loading />
                    <br />
                  </div>
                ) : (
                  <div></div>
                )}

                <div className="columns">
                  {this.state.selectDateRange ? (
                    <div className="column is-4">
                      <div className="">
                        <div className="d-flex justify-content-between">
                          <div className="">
                            <DateRangePicker
                              isOutsideRange={() => false}
                              startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                              startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                              endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                              endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                              onDatesChange={({ startDate, endDate }) => {
                                this.setState(
                                  { startDate, endDate },
                                  this.fetchAddedStocks
                                );
                              }} // PropTypes.func.isRequired,
                              focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                              onFocusChange={(focusedInput) =>
                                this.setState({ focusedInput })
                              } // PropTypes.func.isRequired,
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="column is-4">
                      <button
                        onClick={() => {
                          this.setState({ selectDateRange: true });
                        }}
                        className="button"
                      >
                        <span className="zmdi zmdi-calendar mr-2"></span>
                        {this.state.startDate ? (
                          <span className="mr-1">
                            {new Date(this.state.startDate).toDateString()} -{" "}
                            {new Date(this.state.endDate).toDateString()}
                          </span>
                        ) : (
                          <span className="mr-1">Select a Date Range</span>
                        )}
                        <span className="fas fa-angle-down"></span>
                      </button>
                    </div>
                  )}

                  <div className="column is-4"></div>

                  <div className="column is-4">
                    <div
                      className={
                        "control search-div has-icons-left " + filtering
                      }
                    >
                      <DebounceInput
                        minLength={2}
                        debounceTimeout={500}
                        value={this.state.filterStr}
                        onChange={this.filterStocks}
                        className="input"
                        type="text"
                        placeholder="Filter by name"
                      />
                      <span className="icon is-small is-left">
                        <i className="zmdi zmdi-search"></i>
                      </span>
                    </div>

                    <div className="search-submit-btn">
                      <button
                        onClick={this.makeProductSearch}
                        type="button"
                        className="button"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <div className="has-text-right">
                    <div className="has-text-link is-size-5">
                      <strong> {this.getTotalValue()}</strong>
                    </div>
                  </div>
                </div>

                <div className="overflow-auto">
                  <table className="table is-fullwidth is-responsive is-stripped animated fadeIn is-hoverable mt-4">
                    <thead>
                      <tr>
                        <td>Date</td>
                        <td>Product</td>
                        <td>Qty</td>
                        <td>Expiry Date</td>
                        <td>Value</td>
                        <td>User</td>
                        {this.props.focus === "shop" && !this.state.fetching ? (
                          <td>Status</td>
                        ) : (
                          <td></td>
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.addedStocks.map((stock) => (
                        <tr key={stock.id + "-added-stock"}>
                          <td>
                            <span className="mr-1">
                              {new Date(stock.date_added).toDateString()}
                            </span>
                            <span>
                              {new Date(stock.date_added).toLocaleTimeString()}
                            </span>
                          </td>
                          <td>{stock.name}</td>
                          <td>{stock.qty_added}</td>
                          <td>{stock.expiry_date}</td>
                          <td>
                            {stock.currency}{" "}
                            {(stock.price * stock.qty_added).toLocaleString()}
                          </td>
                          <td>{stock.user_fullname}</td>
                          {this.props.focus === "shop" &&
                          !this.state.fetching ? (
                            <td>
                              {!stock.arrived ? (
                                <div>
                                  <button
                                    title="Cancel"
                                    className="button is-round is-danger"
                                  >
                                    <span className="zmdi zmdi-close-circle"></span>
                                  </button>
                                </div>
                              ) : (
                                <div>
                                  {stock.confirmed ? (
                                    <div>
                                      <span className="zmdi zmdi-check-circle has-text-success"></span>
                                      <small>{stock.confirmed_by}</small>
                                    </div>
                                  ) : (
                                    <div>
                                      {stock.rejected ? (
                                        <div>
                                          <span className="zmdi zmdi-close-circle has-text-danger"></span>
                                          <small>{stock.confirmed_by}</small>
                                        </div>
                                      ) : (
                                        <div>
                                          <span className="zmdi zmdi-check-circle has-text-success"></span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </td>
                          ) : (
                            <td></td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default AddedStocks;
